import classNames from 'classnames';

import useStyles from './styles';

const ClickableHowToFallback = () => {
  const styles = useStyles();

  return (
    <div className={styles.rootFallback}>
      <i className={classNames(styles.title, 'skeleton')} />

      <div className={styles.stepWrapperFallback}>
        {[...Array(5)].map((step, index) => (
          <i
            className={classNames(styles.stepFallback, 'skeleton')}
            key={`ClickableHowToFallback${step}${index}`}
          />
        ))}
      </div>

      <i className={classNames(styles.imageFallback, 'skeleton')} />
      <i className={classNames(styles.descriptionFallback, 'skeleton')} />
    </div>
  );
};

export default ClickableHowToFallback;
